import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import classNames from 'classnames';
import Divider from 'eventbrite_design_system/divider/Divider';
import { types } from '@eb/event-create-publish-utils';
const { PAGE_TYPE_PROP_TYPE } = types;
const MOBILE_EVENT_NAV_CLASSES =
    'manage-nav eds-show-down-sm eds-g-cell eds-text-bs eds-text-weight--heavy';
const DESKTOP_EVENT_NAV_CLASSES =
    'manage-nav eds-show-up-sw eds-g-cell eds-text-bs eds-text-weight--heavy';

const EventNavDivider = () => <Divider direction="vertical" color="grey-800" />;

const NavigationLink = ({
    isActive,
    isLinkShown,
    linkUrl,
    linkText,
    dataAutomationName,
}) => {
    let component = null;

    if (isLinkShown) {
        const eventNavLinkClasses = classNames('manage-nav__link', {
            'manage-nav__link--active': isActive,
        });

        component = (
            <div className="manage-nav__link-container">
                <a
                    href={linkUrl}
                    className={eventNavLinkClasses}
                    data-automation={dataAutomationName}
                >
                    {linkText}
                </a>
            </div>
        );
    }

    return component;
};

export default class EventNavigationBar extends PureComponent {
    static propTypes = {
        eventId: PropTypes.string.isRequired,
        isEditShown: PropTypes.bool.isRequired,
        isSaved: PropTypes.bool.isRequired,
        pageType: PAGE_TYPE_PROP_TYPE.isRequired,
    };

    render() {
        const { eventId, isEditShown, isSaved, pageType } = this.props;
        const editUrl = `/edit?eid=${eventId}`;
        const previewUrl = `/edit?eid=${eventId}&preview=1#preview`;
        const manageUrl = `/myevent?eid=${eventId}`;

        const editLink = (
            <NavigationLink
                isActive={pageType === 'edit'}
                isLinkShown={isEditShown}
                linkUrl={editUrl}
                linkText={gettext('EDIT')}
                dataAutomationName="edit-event"
            />
        );

        const designLink = (
            <NavigationLink
                isActive={pageType === 'design'}
                isLinkShown={true}
                linkUrl={previewUrl}
                linkText={gettext('DESIGN')}
                dataAutomationName="preview-event"
            />
        );

        const manageLink = (
            <NavigationLink
                isActive={pageType === 'manage'}
                isLinkShown={isSaved}
                linkUrl={manageUrl}
                linkText={gettext('MANAGE')}
                dataAutomationName="manage-event"
            />
        );

        const mobileNav = (
            <nav className={MOBILE_EVENT_NAV_CLASSES}>
                {editLink}
                <div className="manage-divider-container">
                    <EventNavDivider />
                </div>
                {manageLink}
            </nav>
        );

        const desktopNav = (
            <nav className={DESKTOP_EVENT_NAV_CLASSES}>
                {editLink}
                <div className="manage-divider-container">
                    <EventNavDivider />
                </div>
                {designLink}
                <div className="manage-divider-container">
                    <EventNavDivider />
                </div>
                {manageLink}
            </nav>
        );

        return (
            <div>
                {mobileNav}
                {desktopNav}
            </div>
        );
    }
}
